export default {
  brainedUserDetails: {},
  selectedProject: {},
  latestMilestone: "",
  users: [],
  versions: [],
  latestVersion: {},
};
